module.exports = __webpack_public_path__ + "d57ad14ca9d2ed1b17309d36ce65e18a.pdf";